import React from 'react';
import { motion } from 'framer-motion';
export function Revelation() {
  const pillars = [{
    num: '1',
    title: 'Optimización de la Autofagia',
    desc: 'Limpieza celular y reciclaje de componentes dañados mediante ayuno estratégico'
  }, {
    num: '2',
    title: 'Hack del Ritmo Circadiano',
    desc: 'Higiene de fotones para apoyar los ritmos naturales de reparación y descanso'
  }, {
    num: '3',
    title: 'Gestión Estratégica del Cortisol',
    desc: 'Dosificación inteligente del estrés y recuperación parasimpática'
  }];
  return <section className="py-24 px-6 bg-gradient-to-b from-brand-bg-alt to-brand-bg" data-id="element-639">
      <div className="max-w-[1000px] mx-auto" data-id="element-640">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16 max-w-[700px] mx-auto" data-id="element-641">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-642">
            El Secreto de los CEOs que Parecen No Envejecer
          </h2>
          <p className="text-sm font-bold tracking-widest text-brand-cyan uppercase mb-8" data-id="element-643">
            NO ES GENÉTICA. ES BIO-OPTIMIZACIÓN 80/20.
          </p>
          <p className="text-lg text-brand-muted leading-relaxed" data-id="element-644">
            Existe un pequeño grupo de ejecutivos de élite en Silicon Valley que
            han descubierto algo: no necesitas protocolos extremos de 5 horas al
            día. El secreto está en 3 'switches' biológicos que, una vez
            activados, fuerzan a tu cuerpo a reciclar células viejas y generar
            energía limpia.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-645">
          {pillars.map((pillar, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.15
        }} className="bg-brand-card rounded-[20px] p-8 border border-brand-border hover:border-brand-cyan/30 transition-colors" data-id="element-646">
              <div className="font-display text-5xl font-bold text-brand-cyan mb-4 opacity-80" data-id="element-647">
                {pillar.num}
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-648">
                {pillar.title}
              </h3>
              <p className="text-brand-muted leading-relaxed" data-id="element-649">{pillar.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center max-w-[800px] mx-auto" data-id="element-650">
          <div className="h-px w-24 bg-gradient-to-r from-transparent via-brand-cyan to-transparent mx-auto mb-8" data-id="element-651" />
          <p className="text-xl text-brand-muted italic leading-relaxed" data-id="element-652">
            "Hemos empaquetado esta ciencia de élite en un sistema que puedes
            implementar en 15 minutos al día. Y ahora, por primera vez, viene
            con una{' '}
            <strong className="text-white not-italic" data-id="element-653">APP INTERACTIVA</strong>{' '}
            que lo hace por ti."
          </p>
        </motion.div>
      </div>
    </section>;
}